
const { ccclass, property } = cc._decorator;
import ViewBase from "../../../table/module/poker_table/poker_table_base_view"
import Q2SeatCards from "./q2_seat_cards";
import Q2TableSeatView from "./q2_table_seat_view";
import Q2DeskCards from "./q2_desk_cards";
import Q2SeatAreaCards from "./q2_seat_area_cards";
import AnimCtr from "./com/anim_ctr";
import Q2TablePoker from "./q2_table_poker";
import Q2MyHandCardsPatterns from "./q2_my_hangcards_patterns";
import Q2MySeatCards from "./q2_myseat_cards";
import PokerRecorder from "../../../table/module/poker_recorder/poker_recorder";

export enum EffectType{  
    HuPai = 1,  
    ZhaDan = 2,
    HuPai_Q = 3,
    HuPai_Dummy = 4,
    LianJiHu = 5,
    QingYiSe = 6,
    NaTouPai = 7,
    ShowQ2 = 8,
    DiuTouPai = 9,
    BeiFangQ2 = 10,
    DiuDummy = 11,
    DiuChengPai = 12,
    GuangTou = 13,
    HuPai_2 = 14,    
    BeiFangQ2_Common = 15,
    
    LianJiHu_QingYiSe,    

    XuanZhuan1,
    XuanZhuan2,
    PaiXing_HuPai,
    PaiXing_LianJiHu,
    PaiXing_LianJiHu_QingYiSe,
    PaiXing_QingYiSe,
    PaiXing_HuPai_Dummy,

    LiuJu,

}

const const_effctType_nameMap = {
    [EffectType.ShowQ2]: 'showQ2',
    [EffectType.BeiFangQ2]: 'beifangQ2',
    [EffectType.BeiFangQ2_Common]: 'common_beifangQ2',
    [EffectType.LianJiHu]: 'lianjihu',
    [EffectType.LianJiHu_QingYiSe]: 'qingyise_lianjihu',
    [EffectType.QingYiSe]: 'qingyise',
    [EffectType.DiuDummy]: 'diuDummy',
    [EffectType.DiuTouPai]: 'diutoupai',
    [EffectType.NaTouPai]: 'natoupai',
    [EffectType.DiuChengPai]: 'diuchengpai',
    [EffectType.GuangTou]: 'guangtou',
    [EffectType.HuPai]: 'hupai',
    [EffectType.HuPai_2]: 'hupai_2',
    [EffectType.HuPai_Q]: 'hupai_Q',
    [EffectType.HuPai_Dummy]: 'hupai_dummy',
    [EffectType.ZhaDan]: 'zhadan',

    [EffectType.XuanZhuan1]: 'xuanzhuan1',
    [EffectType.XuanZhuan2]: 'xuanzhuan2',
    [EffectType.PaiXing_HuPai]: 'paixing_hupai',
    [EffectType.PaiXing_LianJiHu]: 'paixing_lianjihu',
    [EffectType.PaiXing_LianJiHu_QingYiSe]: 'paixing_lianjihu_qingyise',
    [EffectType.PaiXing_QingYiSe]: 'paixing_qingyise',
    [EffectType.PaiXing_HuPai_Dummy]: 'paixing_hupai_dummy',
    [EffectType.LiuJu]: 'GameOverWord',
}

@ccclass
export default class Q2TableViewBase extends ViewBase {
    
    @property(cc.Label)
    timeLabel: cc.Label = null

    @property(cc.Label)
    roomNumLabel: cc.Label = null

    @property(cc.Node)
    nodePokerHeap: cc.Node = null

    @property(cc.Node)
    nodePokerHeapOutAnim: cc.Node = null

    @property(cc.Label)
    labelPokerHeapCount: cc.Label = null

    @property([Q2SeatCards])
    seatHandCardsList: Q2SeatCards[] = []

    @property([Q2SeatAreaCards])
    seatAreaCardsList: Q2SeatAreaCards[] = []

    @property([AnimCtr])
    seatAreaAnimCtrList: AnimCtr[] = []

    @property(AnimCtr)
    commonAnimCtr: AnimCtr = null
    
    @property(Q2DeskCards)
    deskCards: Q2DeskCards = null

    @property([cc.Node])
    nodeDirIconList: cc.Node[] = []

    @property(Q2TablePoker)
    pokerAnimPrefab: Q2TablePoker = null


    @property(Q2MySeatCards)
    mySeatCards: Q2MySeatCards = null

    @property(Q2MyHandCardsPatterns)
    huCardsPattern: Q2MyHandCardsPatterns = null

    @property(cc.Node)
    nodeMask: cc.Node = null

    @property(PokerRecorder)
    pokerRecorder: PokerRecorder = null

    onLoad(){
        super.onLoad()
        this.setSeatCount(4)
        this.resetSeatViewPos()
    }

    setSeatCount(count) {
        super.setSeatCount(count || 4)
    }

    resetSeatAll(i: number){
        super.resetSeatAll(i)
        this.showSeatHandCards(i, false)
        this.showSeatClock(i, false)
        this.showSeatHandCards(i, false)
        this.showSeatKickBtn(i, false)   
        this.showSeatClock(i, false)
        this.showSeatScore(i, false)
        this.showAreaCards(i, false, [])
        this.showSeatSelected(i, false)
        this.showSeatWatchTag(i, false)
        this.showAreaCards(i, false, [])
    }

    resetView(){
        super.resetView()
        this.showPokerHeap(false)
        this.deskCards.showPokers(false)
        this.mySeatCards.showPokers(false)
        this.showDirectionIcon(false, 0)
    }

    getSeatIndexSequence():number[]{
        let sequence = []
        let seatCount = this.getSeatCount()
        for (let index = 0; index < seatCount; index++) {            
            sequence.push(index)
        }
        return sequence
    }

    refreshTime(show: boolean, date?: Date){
        if(!show){
            this.timeLabel.node.parent.active = false
            return
        }
        this.timeLabel.node.parent.active = true
        let nowDate = date? date: new Date(Date.now())
        this.timeLabel.string = nowDate.getHours() + ':' + nowDate.getMinutes()
    }

    showSeatWatchTag(localPos: number, show: boolean){
        let seatView = this.getSeatViewByPos(localPos) as Q2TableSeatView
        seatView.showWatchTag(show)
    }

    showSeatHandCards(localPos: number, show: boolean, codeList?: number[], params?: any){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.showPokers(show, codeList, params)
    }

    bindSeatHandCardsUid(localPos: number, uid: number){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.uid = uid
    }

    showSeatHandCardsBg(localPos: number, show: boolean){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.showBg(show)
    }

    showSeatHandCardsCount(localPos: number, show: boolean, leftCount?: number){
        let seatHandCards = this.seatHandCardsList[localPos]
        seatHandCards.showLeftCardCount(show, leftCount)
    }

    playSeatPiaoFenAnim(localPos: number, score: number, onFinish?: Function, clipIndex?: number){
        let avatar = this.getAvatarById(localPos)
        if(avatar){
            avatar.playScoreChangeAnim(()=>{
                let seatView = this.getSeatViewByPos(localPos) as Q2TableSeatView
                seatView.showPiaoFenAnim(true, score, onFinish, clipIndex)
            })
        }        
    }

    showPokerHeap(show: boolean, leftCount?: number){
        this.nodePokerHeap.active = !!show
        if(show){
            this.labelPokerHeapCount.string = leftCount + ''
        }        
    }    

    showPokerHeapChangeAnim(onFinish?: Function){
        let node = this.nodePokerHeapOutAnim
        node.active = true
        this.doScheduleOnce(()=>{
            node.active = false
            onFinish && onFinish()
        }, 0.5)
    }

    showSeatClock(localPos: number, show: boolean, secs?: number, needShake?: boolean, onFinish?: Function, onTick?: Function, totalSecs?: number) {
        let seatView = this.getSeatViewByPos(localPos) as Q2TableSeatView
        totalSecs = totalSecs || 10
        seatView.showClock(show, secs, needShake, onFinish, onTick, totalSecs)
    }

    showAreaCards(localPos: number, show: boolean, codePatternList: number[][]){
        let cardsView = this.seatAreaCardsList[localPos]
        cardsView.showPokers(show, codePatternList)
    }

    playAreaCardsInAnim(localPos: number, index: number, codeList: number[], onFinish: Function, params: {codeList: number[], type: number, fromCompleteProcess: boolean}){
        let cardsView = this.seatAreaCardsList[localPos]
        cardsView.playCardInAnim(index, codeList, onFinish, params)
    }

    playSeatHandCardInAnim(localPos: number, codeList: number[], onFinish?: Function){
        let cardsView = this.seatHandCardsList[localPos]
        cardsView.playCardInAnim(codeList, onFinish)
    }

    playSeatHandCardOutAnim(localPos: number, codeList: number[], onFinish?: Function){
        let cardsView = this.seatHandCardsList[localPos]
        cardsView.playCardOutAnim(codeList, onFinish)
    }

    playSeatFaPaiAnim(localPos: number, codeList: number[], onFinish?: Function){
        let cardsView = this.seatHandCardsList[localPos]
        cardsView.playFaPaiAnim(codeList, onFinish)
    }

    showDirectionIcon(show: boolean, dir: number){
        let dirIndex = dir - 1
        for (let index = 0; index < this.nodeDirIconList.length; index++) {
            const element = this.nodeDirIconList[index];
            element.active = show && index == dirIndex
        }
    }

    playDirectionAnim(dir: number, onFinish?: Function){
        let effectType = dir == 1? EffectType.XuanZhuan1: EffectType.XuanZhuan2
        this.playCommonAnim(effectType, onFinish)
    }

    playLiuJuAnim(onFinish?: Function){
        this.playCommonAnim(EffectType.LiuJu, onFinish)
    }

    playDeskCommonCardInAnim(codeList: number[], onFinish?: Function){
        this.deskCards.playCardInAnim(codeList, onFinish)
    }

    playDeskFirstCommonCardInAnim(code: number, onFinish?: Function){
        this.deskCards.playFirstCardInAnim([code], onFinish)
    }

    playDeskCommonCardOutAnim(codeList: number[], onFinish?: Function){
        this.deskCards.playCardOutAnim(codeList, onFinish)
    }

    playAreaAnim(localPos: number, effectType: EffectType, onFinish?: Function){
        let animCtr = this.seatAreaAnimCtrList[localPos]
        let name = const_effctType_nameMap[effectType]
        animCtr.playAnim(name, onFinish)
    }

    playSeatHuPokerAnim(localPos: number, code: number, onFinish: Function, uid: number){
        let self = this
        let animCtr = localPos == 0? this.commonAnimCtr: this.seatAreaAnimCtrList[localPos]
        let scale = localPos == 0? 1.2: 0.667
        let poker = this.pokerAnimPrefab
        poker.uid = uid
        poker.node.parent = animCtr.nodeParent1
        poker.node.position = cc.Vec2.ZERO
        poker.node.scale = scale
        poker.onUpdateBack()
        poker.setFace(code)
        poker.show()
        self.doScheduleOnce(function(){
            poker.hide()
            onFinish && onFinish()
        }, 4)
    }

    playCommonAnim(effectType: EffectType, onFinish?: Function){
        let name = const_effctType_nameMap[effectType]
        this.commonAnimCtr.playAnim(name, onFinish)
    }

    showSeatSelected(localPos: number, show: boolean) {
        let cardsView = this.seatAreaCardsList[localPos]
        cardsView.showSelectBg(show)
    }

    showQuickHuCards(show: boolean, raiseCodeList?: number[], storageCodeList?: number[], attachCodeList?: number[], discardCode?: number){
        this.mySeatCards.node.active = !show
        this.huCardsPattern.node.active = !!show
        if(show){
            this.huCardsPattern.showPokers(true, raiseCodeList, storageCodeList, attachCodeList, discardCode)
        }
    }

    showRoomNumLabel(show: boolean, roomNum: string){
        this.roomNumLabel.node.active = !!show
        if(show){
            this.roomNumLabel.string = roomNum
        }
    }

    showMask(show: boolean){
        this.nodeMask.active = !!show
    }

    showPokerRecorder(show: boolean, showShort?: boolean, withOutDeal?: boolean){
        this.pokerRecorder.showRecord(show, showShort, withOutDeal)
    }

    refreshPokerRecorder(data){
        this.pokerRecorder.setData(data)
    }

    showSeatScore(pos: number, show: boolean, score?: number) {
        super.showSeatScore(pos, show, score)
        let avatar = this.getAvatarById(pos)
        if(!avatar){
            return
        }
        if(show){
            let str = score >= 0?'#fffa69':'#57f147'
            avatar.setCoinBalanceColor(cc.Color.BLACK.fromHEX(str))
        }        
    }
}
